import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import { AutocompleteInput } from '../../../Components/Inputs/AutocompleteInput'
import { InputOptionProps } from '../../../Components/Inputs/Types'
import { AppPermission, useAppPermissions } from '../../../Hooks/useAppPermissions'
import { LabSchema } from '../../../Schema/LabSchema'
import { useChargeCodesSelector } from '../Hooks/useChargeCodesSelector'
import { ChargeCodeAddDrawer } from '../ChargeCodeAddDrawer'
import { ChargeCodeSchema } from '../../../Schema/ChargeCodeSchema'

interface ChargeCodePickerProps {
  value?: string
  className?: any
  label?: string
  helperText?: string
  onChange: (value: string) => void
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  onCreateNew?: (text: string) => void
  enableCreate?: boolean
  error?: boolean
}

export const ChargeCodePicker: React.FC<ChargeCodePickerProps> = ({
  className,
  value,
  label,
  helperText,
  onChange,
  disabled,
  required,
  variant,
  placeholder,
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate = true,
  error,
}) => {
  const { checkPermissions } = useAppPermissions()

  const [openAdd, setOpenAdd] = useState(false)
  const [text, setText] = useState<string>('')

  const codes = useChargeCodesSelector()

  const options: InputOptionProps[] = useMemo(() => {
    return _.map(codes, c => c.getInputOption())
  }, [codes])

  const handleOnCreate = (name?: string) => {
    setOpenAdd(true)
    setText(
      name,
    )
  }

  const handleOnCloseAdd = (schema?: ChargeCodeSchema) => {
    if (schema) {
      onChange(schema.id)
    }
    setOpenAdd(false)
  }
  return (
    <>
    <AutocompleteInput
      value={value}
      className={className}
      label={label}
      helperText={helperText}
      onChange={value => onChange(value as string)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      options={options}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      onCreateNew={handleOnCreate}
      enableCreate={checkPermissions([AppPermission.ChargeCodeAdd]) && enableCreate}
      error={error}
    />
    <ChargeCodeAddDrawer
      open={openAdd}
      onClose={handleOnCloseAdd}
      defaultData={{
        code: text,
      }}
    />
    </>
  )
}
